// src/utils/request.js
import CryptoJS from 'crypto-js';

// 签名配置 - 需要和后端 CommonConst 保持一致
const SIGN_CONFIG = {
    appId: 'wx1fe6d273093c7b8a', // 对应后端 CommonConst::WX_APPLET_ID
    secret: 'SHAKLEE-kj9J)&Qd#lB', // 对应后端 CommonConst::SIGN_SECRET，请确认是否一致
};

/**
 * 对参数按 key 排序（对应后端 param_ksort）
 * 递归处理嵌套对象/数组
 */
const paramKsort = (params) => {
    if (typeof params !== 'object' || params === null) {
        return params;
    }
    if (Array.isArray(params)) {
        return params.map(item => paramKsort(item));
    }
    const sorted = {};
    Object.keys(params).sort().forEach(key => {
        sorted[key] = paramKsort(params[key]);
    });
    return sorted;
};

/**
 * JSON 编码（对应后端 json_format）
 * 对应后端 json_encode 的实际参数：JSON_HEX_AMP | JSON_UNESCAPED_UNICODE
 */
const jsonFormat = (params) => {
    return JSON.stringify(params)
        .replace(/\//g, '\\/')
        .replace(/&/g, '\\u0026');
};

/**
 * 生成 HMAC-SHA256 签名
 * 对应后端: hash_hmac('sha256', WX_APPLET_ID . $encodeParams, SIGN_SECRET)
 */
const generateSign = (encodeParams) => {
    const dataToSign = SIGN_CONFIG.appId + encodeParams;
    const hmac = CryptoJS.HmacSHA256(dataToSign, SIGN_CONFIG.secret);
    return hmac.toString(CryptoJS.enc.Hex);
};

/**
 * 计算请求签名
 * 逻辑：合并 query 参数(去掉 sign/debug/user) + body 参数 → ksort → json → HMAC
 */
const calcSign = (queryParams, bodyParams) => {
    // base64 图片/PDF 字段用 md5 摘要替代（对应后端逻辑）
    const processedBody = { ...bodyParams };
    Object.keys(processedBody).forEach(key => {
        const val = processedBody[key];
        if (typeof val === 'string' &&
            (val.startsWith('data:image/') || val.startsWith('data:application/pdf;base64,'))) {
            processedBody[key] = CryptoJS.MD5(val).toString();
        }
    });

    // 合并 query + body
    const mergedParams = { ...queryParams, ...processedBody };

    // 按 key 排序
    const sortedParams = paramKsort(mergedParams);

    // JSON 编码
    const encodeParams = jsonFormat(sortedParams);

    // 生成签名
    return generateSign(encodeParams);
};

const makeRandString = (length = 10) => {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';

    for (let i = 0; i < length; i += 1) {
        result += chars.charAt(Math.floor(Math.random() * chars.length));
    }

    return result;
};

const encodeRequestData = (params) => {
    const json = jsonFormat(params);
    const base64 = CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(json));
    return makeRandString(10) + base64;
};

export async function requestApi(funcUrl, params, shakleeId) {
    const timestamp = Math.floor(Date.now() / 1000);
    // const apiHost = "http://localhost:9502";
    // const apiHost = "https://test-miniapp.shaklee.com.cn";
    const apiHost = "https://miniapp.shaklee.com.cn";

    try {
        // query 参数（对应后端注释里提到的前端只取这三个）
        const queryParams = {
            'client-v': '1.0',
            'system': 'miniProgram',
            'time': timestamp + '',
        };

        // 拼接 URL
        const apiSign = calcSign(queryParams, params);
        const queryString = `sign=${apiSign}&client-v=${queryParams['client-v']}&system=${queryParams['system']}&time=${queryParams['time']}`;
        const apiUrl = `${apiHost}${funcUrl}?${queryString}`;

        // 后端要求 body 只传 data：10位随机前缀 + base64(JSON)
        const bodyString = new URLSearchParams({
            data: encodeRequestData(params),
        }).toString();

        const response = await fetch(apiUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
                'Shaklee_Id': shakleeId,
                'referer': 'h5login.com',
            },
            body: bodyString,
        });

        console.log(apiUrl);

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }

        const data = await response.json();
        console.log(data);

        if (data.code === 0) {
            console.log(funcUrl + "成功", data.data);
        } else {
            console.log(funcUrl + "失败: " + data.message);
        }
        return data;
    } catch (error) {
        console.error(error);
        return false;
    }
}

export function checkMobileNo(mobileNo) {
    const phoneRegex = /^1[3-9]\d{9}$/;
    if (mobileNo == "" || !phoneRegex.test(mobileNo)) {
        return false;
    }
    return true;
}

export function checkIDNumber(idNumber) {
    // 15位和18位身份证号码的正则表达式
    const reg15 = /^(\d{15})$/;
    const reg18 = /^(\d{17})([0-9Xx])$/;
    const factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
    const checksumMap = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'];

    if (reg15.test(idNumber)) {
        return true;
    } else if (reg18.test(idNumber)) {
        // 进一步验证18位身份证号码的校验码
        let sum = 0;
        for (let i = 0; i < 17; i++) {
            sum += parseInt(idNumber.charAt(i), 10) * factor[i];
        }
    
        const checksumIndex = sum % 11;
        const expectedChecksum = checksumMap[checksumIndex];
        return idNumber.charAt(17).toUpperCase() === expectedChecksum;
    } else {
        return false;
    }
}


// 导出工具函数
export { paramKsort, jsonFormat, generateSign, calcSign };



// WEBPACK FOOTER //
// ./src/utils/request.js